import axios from "axios";
import { endpoints } from "../_config";

class SurveysService {
  /**
   * Get All Surveys
   * @param {*} Bearer token
   * @returns
   */
  static async getSurveys(user, params) {
    return axios
      .get(endpoints.surveys.getAllSurveys, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
        params,
      })
      .then((response) => response.data);
  }

  /**
   * Create Survey Api
   * @param {*}
   * @returns
   */
  static async createSurvey(user, data) {
    return axios
      .post(endpoints.surveys.create, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get Single Survey Details
   * @param {*} Bearer token
   * @returns
   */
  static async getSurvey(user, surveyId) {
    return axios
      .get(endpoints.surveys.getSurvey(surveyId), {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get Single Question By Filter
   * @param {*} Bearer token
   * @returns
   */
  static async getSurveyByFilter(user, params) {
    return axios
      .get(endpoints.surveys.getAllSurveys, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
        params,
      })
      .then((response) => response.data);
  }
}

export { SurveysService };
